import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative bg-[#0B0F17] text-white overflow-hidden">
      {image && <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />}
      <div className="absolute inset-0 hero-overlay" />
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-20 lg:py-28">
        <p className="eyebrow text-primary">{eyebrow}</p>
        <h1 className="mt-4 text-4xl sm:text-5xl font-heading font-extrabold tracking-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`max-w-7xl mx-auto px-4 lg:px-8 py-16 lg:py-20 ${className}`}>{children}</section>;
}

export function SectionTitle({ eyebrow, title, subtitle, center }) {
  return (
    <div className={`mb-12 ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      {eyebrow && <p className="eyebrow text-primary">{eyebrow}</p>}
      <h2 className="mt-3 text-3xl lg:text-4xl font-heading font-extrabold tracking-tight">{title}</h2>
      {subtitle && <p className="mt-4 text-muted-foreground leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function CTA() {
  return (
    <section className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h2 className="text-3xl font-heading font-extrabold">Ready to move your cargo?</h2>
          <p className="mt-2 text-white/85">Get an instant quote or track a shipment in real time.</p>
        </div>
        <div className="flex gap-3">
          <Link to="/quote"><Button size="lg" className="bg-white text-primary hover:bg-slate-100" data-testid="cta-quote">Request a Quote</Button></Link>
          <Link to="/track"><Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" data-testid="cta-track">Track Shipment</Button></Link>
        </div>
      </div>
    </section>
  );
}

export function FeatureCard({ icon: Icon, title, desc }) {
  return (
    <div className="rounded-xl border border-border bg-card p-6 card-hover">
      <div className="w-12 h-12 rounded-xl bg-accent text-primary flex items-center justify-center">
        <Icon size={24} />
      </div>
      <h3 className="mt-4 font-heading font-bold text-lg">{title}</h3>
      <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{desc}</p>
    </div>
  );
}
